import React from 'react'

const Spinner = ({ className }) => <div className={`spinner-border text-primary ${className}`} role="status" />

export default Spinner
